import { Box, Icon, SelectProps } from '@chakra-ui/react';
import { ReactNode, useState } from 'react';

import { ChevronDownIcon } from '../../icons';

interface CustomDropdownProps extends SelectProps {
  options: { id: string; name: string; icon: ReactNode }[];
  placeholder: string;
  getMappedNetwork: (name: string) => { name: string; icon: ReactNode };
  setFieldValue: (field: string, value: string) => void;
  fieldValue: string;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  options,
  placeholder,
  getMappedNetwork,
  setFieldValue,
  value,
  fieldValue,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value ?? '');

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (name: string) => {
    setSelectedOption(name);
    setIsOpen(false);
    setFieldValue(fieldValue, name);
  };

  return (
    <Box position="relative">
      <Box
        onClick={toggleDropdown}
        bg="white"
        py={4}
        px={3}
        border="1px solid #ebedef"
        borderRadius="12px"
        cursor="pointer"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        boxShadow={isOpen ? '0px 4px 6px rgba(0, 0, 0, 0.1)' : 'none'}
        transition="box-shadow 0.3s, border-radius 0.3s"
      >
        {selectedOption ? (
          <Box ml={2}>{selectedOption}</Box>
        ) : (
          <>
            <Box>{placeholder}</Box>
            <Icon as={ChevronDownIcon} mr={2} />
          </>
        )}
      </Box>
      {isOpen && (
        <Box
          position="absolute"
          top="100%"
          left={0}
          width="100%"
          border="1px solid #ccc"
          borderRadius={isOpen ? '10px 10px 12px 12px' : 'md'}
          bg="white"
          boxShadow="0px 4px 6px rgba(0, 0, 0, 0.1)"
          zIndex={1}
          transition="box-shadow 0.3s, border-radius 0.3s"
        >
          {options.map(({ id, name, icon }) => {
            const network = getMappedNetwork(name);
            return (
              <Box
                key={id}
                py={2}
                px={3}
                cursor="pointer"
                onClick={() => handleOptionSelect(name)}
                display="flex"
                alignItems="center"
                _hover={{ bg: '#EBEDEF', color: 'black' }}
              >
                <Box
                  borderRadius="8px"
                  overflow="hidden"
                  width="36px"
                  height="36px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  mr={2}
                >
                  {network.icon}
                </Box>
                <Box ml={2}>{network.name}</Box>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default CustomDropdown;
